export default {
  namespaced: true,
  name: 'SLSEsPrioriStore',
  state: () => ({
    loading: false,
    filters: {
      page: 1,
      pages: 10,
      total: null,
    },
    prioridadesPedido: [],
  }),
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_PRIORIDADES_PEDIDO(state, payload) {
      state.prioridadesPedido = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = { ...state.filters, ...payload };
    },
  },
  getters: {
    GET_LOADING(state) {
      return state.loading;
    },
    GET_PRIORIDADES_PEDIDO(state) {
      return state.prioridadesPedido;
    },
    GET_FILTERS(state) {
      return state.filters;
    },
  },
};
